import { Quote } from "lucide-react";

const TESTIMONIALS = [
    {
        text: "Mélanie comprend instantanément l'ADN d'une marque. Ses vidéos ont doublé notre ROAS sur Meta Ads en moins d'un mois.",
        author: "Sophie L.",
        role: "Brand Manager, marque skincare",
    },
    {
        text: "Travailler avec Mélanie c'est avoir un vrai partenaire créatif. Brief compris, livré nickel, vidéos qui convertissent.",
        author: "Karim B.",
        role: "Growth Lead, e-commerce mode",
    },
    {
        text: "Esthétique premium, authenticité bluffante. On a trouvé notre créatrice UGC de référence.",
        author: "Elise M.",
        role: "Fondatrice, marque beauté",
    },
];

export default function Testimonials() {
    return (
        <section
            data-testid="testimonials-section"
            className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-white"
        >
            <div className="max-w-[1600px] mx-auto">
                <div className="mb-16 text-center">
                    <p className="eyebrow mb-5">Témoignages</p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.02]">
                        Ce qu'elles <span className="italic">en disent</span>.
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {TESTIMONIALS.map((t, i) => (
                        <figure
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className="border border-[#E5E5E5] p-8 md:p-10 bg-white hover:border-gold transition-colors"
                        >
                            <Quote className="w-6 h-6 text-fuchsia mb-6" />
                            <blockquote className="font-display text-xl md:text-2xl leading-snug text-ink">
                                "{t.text}"
                            </blockquote>
                            <figcaption className="mt-8 border-t border-[#E5E5E5] pt-5">
                                <p className="text-sm font-medium text-ink">{t.author}</p>
                                <p className="text-[10px] uppercase tracking-[0.22em] text-[#4A4A4A] mt-1">
                                    {t.role}
                                </p>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
